export type NumberTsEnum = {
  [key: string]: string | number;
  [key: number]: string;
};
export type StringTsEnum<EnumType extends string = string> = Record<string, EnumType>;

export function allEnumValues<EnumType extends number | string>(tsEnum: any): EnumType[] {
  const values = Object.values(tsEnum);

  const numericValues = values.filter((value) => typeof value === 'number');
  // if there are numeric values, then its a numeric enum
  if (numericValues.length > 0) {
    return numericValues as EnumType[];
  }

  // otherwise, its a string enum
  return values.filter((value) => typeof value === 'string') as EnumType[];
}

export function isValidEnumValue<EnumType extends number | string>(
  tsEnum: any,
  value: number | string | undefined,
): value is EnumType {
  return allEnumValues<EnumType>(tsEnum).includes(value as EnumType);
}

export function areValidEnumValues<EnumType extends number | string>(
  tsEnum: any,
  values: (number | string)[],
): values is EnumType[] {
  return values.every((value) => isValidEnumValue<EnumType>(tsEnum, value));
}

export function mapEnumToRecord<EnumType extends number | string, RecordValue>(
  tsEnum: any,
  mapper: (tsEnumKey: EnumType) => RecordValue,
): Record<EnumType, RecordValue> {
  return allEnumValues<EnumType>(tsEnum).reduce<Partial<Record<EnumType, RecordValue>>>(
    (partialRecord, tsEnumKey) => {
      return {
        ...partialRecord,
        [tsEnumKey]: mapper(tsEnumKey),
      };
    },
    {},
  ) as Record<EnumType, RecordValue>;
}
